import React, {useCallback, useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import { Tabs, Tooltip } from "antd";
import { Spin, Modal, message,Badge } from "antd";
import {
  getFirstDateOfWeek,
  getLastDateOfWeek,
  getMySqlDate,
} from "utils/Date";
import LeaveForm from "organisms/LeaveForm";
import { CALL_API } from "common/API";
import { connect } from "react-redux";
import {
  getAllDepartmentList,
  getUserRoleId,
  getSelectedDepartmentId,
  getUserInfo,
  getClientid,
  getMenuList,
  getLeaveCategoryList,
  getUserList,
  getRoleList,
} from "redux/selectors";
import {
  get,
  includes,
  isEmpty,
  orderBy,
  some,
} from "lodash";
import { getAllSubordinates, STATUS_CODE } from "common/Constants";
// import { CalendarContext } from ".";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import StaffLeaveIndicatorInCalendar from "pages/Calendar/StaffLeaveIndicatorInCalendar";
import {StyledHolidayBadge} from "../Calendar/StyledComponents";
import { useSelector } from "react-redux";
import styled from "styled-components";

const Stylediv = styled.div`
  .fc .fc-holiday-week {
    background-color: rgba(255, 0, 0, 0.2) !important;
  }
`;

const FC_PLUGINS = [timeGridPlugin, dayGridPlugin, interactionPlugin];
const FC_HIDDEN_DAYS = [0];
const FC_HEADER_TOOLBAR = {
  left: "prev,next",
  center: "title",
  right: "timeGridWeek,dayGridMonth",
};

const getEventColor = (statusId, havingCancelRequest) => {
  if (statusId === "5" && havingCancelRequest === "1") return "#FBE2CD";
  switch (parseInt(statusId, 10)) {
    case 4: return "#FBE2CD";
    case 5: return "#E2FBCD";
    case 6: return "#FFCCCB";
    default: return "#ADD8E6";
  }
};

const getEventBorderColor = (statusId, havingCancelRequest) => {
  if (statusId === "5" && havingCancelRequest === "1") return "#F18D38";
  switch (parseInt(statusId, 10)) {
    case 4: return "#F18D38";
    case 6: return "#38CDF1";
    case 5: return "#78F138";
    default: return "#F18D38";
  }
};

function LeaveWeekCalendar({
  userRoleId,
  userInfo,
  ClientId,
  menuList,
  userList,
  setTabId,
  tabId,
  clientId
}) {

  const [holidayList, setHolidayList] = useState([]);
  const getHolidayList = useCallback(async (startdate, enddate) => {
    try {
      const response = await CALL_API(`holiday-list/${ClientId}`, "post", {
        start_date: moment(startdate).format("yyyy-MM-DD"),
        end_date: moment(enddate).format("yyyy-MM-DD"),
      });
      if (!isEmpty(response)) {
        setHolidayList(orderBy(response, ["start_date"], ["asc"]));
      } else {
        setHolidayList([]);
      }
    } catch (error) {
      console.error("[getHolidayList], Error-->", error);
    }
  }, [ClientId]);

  const { TabPane } = Tabs;
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  
  let tabMenus = Menulist.filter(
    (item) =>
      item.key === "mycalendar" ||
      item.key === "teamcalendar" ||
      item.key === "allcalendar"
  );

  let newArray = [];
  newArray.push(...tabMenus);

  const items =
    newArray &&
    newArray
      ?.filter((data) => data.access === true)
      .map((data, index) => ({
        id: data.subtitle,
        label: data.subtitle,
        component: <></>,
      }));

  const [activeTab, setActiveTab] = useState("Mine");

  const [displayLeaveModal, toggleLeaveModal] = useState(false);

  const [leaveDetails, setLeaveDetails] = useState({});
  const [showMyTeamLeaves, toggleMyTeamLeave] = useState(false);

  const filteruser = useMemo(
    () => userList?.filter((item) => item?.userid === userInfo.userid),
    [userList, userInfo.userid]
  );

  const isSuperAdmin = userInfo?.roleId === "383";
  const isCountryAdmin = userInfo?.roleId === "386";

  const [payload, setPayload] = useState({
    status_id: "4,5",
    officesupervisorid: tabId === "My Team" ? filteruser[0]?.employeeid : [""],
    start_date: getFirstDateOfWeek(moment()),
    end_date: getLastDateOfWeek(moment()),
    show_my_team_leave: tabId === "My Team" ? true : false,
    ...(isSuperAdmin && { supeAdmin: tabId === "My Team" ? false : true }),
    ...(isCountryAdmin && { countryAdmin: tabId === "My Team" ? false : true }),
    ...(isCountryAdmin && { country: tabId === "My Team" ? "" : filteruser[0]?.managingoffice[0] }),
  });
  const [endDate, setEndDate] = useState("");

  moment.updateLocale("en", {
    weekdaysMin: ["S", "M", "T", "W", "T", "F", "S"],
  });

  const handleTabSelect = (key) => {
    const activeTab = items.find((item) => item.id === key);
    if (activeTab) {
      setTabId(activeTab.label);
    }

    if (key === 0) {
      toggleMyTeamLeave(!showMyTeamLeaves);
    }
  };

  const calendarRef = useRef(null);

  const queryString = new URLSearchParams(payload).toString();

  const { key, url } = queryKeys.getLeaveList(ClientId, queryString);

  const {
    data: leaveDataRes,
    isLoading: displayLoader,
    refetch: getLeaveList,
  } = useFetch(
    key,
    url,
    {
      enabled: !!ClientId,
    },
    payload
  );


  const addLeave = (event, cellDate) => {
    if (userRoleId != 1) {
      const isPastDate =
        moment(getMySqlDate(cellDate)) < moment(getMySqlDate("2022-08-01"));
      if (!isPastDate) {
        toggleLeaveModal(true);
        setLeaveDetails({
          start_date: cellDate,
          end_date: cellDate,
        });
      }
    }
  };

  const cancelLeaveRequest = useCallback((details) => {
    const {
      user_leave_id,
      start_date: leave_start_date,
      end_date: leave_end_date,
      status_id,
      userid
    } = details;
    if (userRoleId !== 1 && status_id !== "4") {
      Modal.confirm({
        icon: "",
        content: "Are you sure you want to cancel your leave application?",
        okText: "Yes",
        cancelText: "No",
        onOk: () => {
          return new Promise(async (resolve) => {
            const { code } = await CALL_API(
              `approve-reject-cancel-leave/${ClientId}`,
              "post",
              {
                user_leave_id,
                leave_applied_userid: userid,
                status_id: "9",
                is_cancel_request: false,
                start_date: getMySqlDate(leave_start_date),
                end_date: getMySqlDate(leave_end_date),
              }
            );
            if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
              message.error(`Oops!! something went wrong.`);
            } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
              message.error(`Invalid payload. Please enter correct data.`);
            } else if (code === STATUS_CODE.RECORD_EXIST) {
              message.error(`Leave aleady exist.`);
            } else if (code === STATUS_CODE.SUCCESS) {
              message.success(`Your leave application has been cancelled.`);
              getLeaveList();
            }
            resolve();
          }).catch((err) => console.error("[cancelLeaveRequest] Error -->", err));
        },
      });
    } else {
      setLeaveDetails(details);
      toggleLeaveModal(true);
    }
  }, [userRoleId, ClientId, getLeaveList]);

  const cancelLeave = useCallback((details) => {
    const {
      user_leave_id,
      start_date: leave_start_date,
      end_date: leave_end_date,
      status_id,
      userid
    } = details;
    if (userRoleId !== 1 && status_id === "4") {
      Modal.confirm({
        icon: "",
        content: "Are you sure you want to cancel your leave application?",
        okText: "Yes",
        cancelText: "No",
        onOk: () => {
          return new Promise(async (resolve) => {
            const { code } = await CALL_API(
              `approve-reject-cancel-leave/${ClientId}`,
              "post",
              {
                user_leave_id,
                leave_applied_userid: userid,
                status_id: "9",
                is_cancel_request: false,
                start_date: getMySqlDate(leave_start_date),
                end_date: getMySqlDate(leave_end_date),
              }
            );
            if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
              message.error(`Oops!! something went wrong.`);
            } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
              message.error(`Invalid payload. Please enter correct data.`);
            } else if (code === STATUS_CODE.RECORD_EXIST) {
              message.error(`Leave aleady exist.`);
            } else if (code === STATUS_CODE.SUCCESS) {
              message.success(`Your leave application has been cancelled.`);
              getLeaveList();
            }
            resolve();
          }).catch((err) => console.error("[cancelLeave] Error-->", err));
        },
      });
    } else {
      setLeaveDetails(details);
      toggleLeaveModal(true);
    }
  }, [userRoleId, ClientId, getLeaveList]);

  const events = useMemo(() => {
    const myLeaveList = leaveDataRes?.response?.leaves?.filter(
      (val) => val?.userid === get(userInfo, "userid", "")
    );
    const myTeamLeaveList = leaveDataRes?.response?.teamLeaves;
    const allLeaveList = leaveDataRes?.response?.leaves;

    let leaveList = [];
    switch (activeTab) {
      case "Mine":
        leaveList = myLeaveList;
        break;
      case "My Team":
        leaveList = myTeamLeaveList;
        break;
      case "All":
        leaveList = allLeaveList;
        break;
      default:
        leaveList = myLeaveList;
    }
    return leaveList?.map((event) => {
      const isCancelRequested =
        event.status_id === "5" && event.having_cancel_request === "1";
      const rawStartDate = isCancelRequested
        ? event.new_start_date
        : event.start_date;
      const rawEndDate = isCancelRequested
        ? event.new_end_date
        : event.end_date;
      const startDateTime = moment(rawStartDate)
        .set({ hour: 8, minute: 0 })
        .toISOString();
      const endDateTime = moment(rawEndDate)
        .set({
          hour: Number(event.number_of_days) === 0.5 ? 12 : 17,
          minute: 0,
        })
        .toISOString();
      return {
        id: event.id || `${event.fullname}-${rawStartDate}`, // Add unique id
        title: `${event.fullname} | ${event.leave_category_name}`,
        start: startDateTime,
        end: endDateTime,
        status: event.status_id,
        having_cancel_request: event.having_cancel_request,
        ...event,
      };
    });
  }, [activeTab, leaveDataRes, userInfo]);

  const handleDatesSet = useCallback((arg) => {
    const startOfWeek = arg.start; // Start of the week (Date object)
    const endOfWeek = arg.end; // End of the week (Date object)
    const viewType = arg.view.type

    // You can format these dates as needed
    const formattedStart = startOfWeek.toISOString().split("T")[0];
    const formattedEnd = endOfWeek.toISOString().split("T")[0];

    setPayload({
      status_id: "4,5",
      officesupervisorid: tabId === "My Team" ? filteruser[0]?.employeeid : [""],
      start_date: moment(formattedStart).format("YYYY-MM-DD"),
      end_date: moment(formattedEnd).format("YYYY-MM-DD"),
      show_my_team_leave: tabId === "My Team" ? true : false,
      ...(isSuperAdmin && { supeAdmin: tabId === "My Team" ? false : true }),
      ...(isCountryAdmin && { countryAdmin: tabId === "My Team" ? false : true }),
      ...(isCountryAdmin && { country: tabId === "My Team" ? "" : filteruser[0]?.managingoffice[0] }),
    });

    getHolidayList(
      viewType === "dayGridMonth"
        ? moment(arg.view.getCurrentData().currentDate).startOf('month').format("YYYY-MM-DD")
        : moment(arg.start).format("YYYY-MM-DD"),
      viewType === "dayGridMonth"
        ? moment(arg.view.getCurrentData().currentDate).endOf('month').format("YYYY-MM-DD")
        : moment(arg.end).format("YYYY-MM-DD")
    );
  }, [tabId, filteruser, isSuperAdmin, isCountryAdmin, getHolidayList]);

  const currentUser = useMemo(
    () => userList?.find((item) => item?.userid === userInfo.userid),
    [userList, userInfo.userid]
  );
  const baselocationid = currentUser?.baselocationid;

  const renderDayCellClassNames = useCallback((arg) => {
    if (arg.view.type !== "timeGridWeek") return [];
    const dateStr = moment(arg.date).format("YYYY-MM-DD");
    const isHoliday = holidayList.some(
      (holiday) =>
        moment(holiday.start_date).format("YYYY-MM-DD") <= dateStr &&
        moment(holiday.end_date).format("YYYY-MM-DD") >= dateStr &&
        holiday.location_id?.includes(baselocationid)
    );
    return isHoliday ? ["fc-holiday-week"] : [];
  }, [holidayList, baselocationid]);

  const renderDayCellContent = useCallback((arg) => {
    const dateStr = moment(arg.date).format("YYYY-MM-DD");
    if (arg.view.type !== "dayGridMonth") {
      const matchedHoliday = holidayList.find(
        (holiday) =>
          moment(holiday.start_date).format("YYYY-MM-DD") <= dateStr &&
          moment(holiday.end_date).format("YYYY-MM-DD") >= dateStr &&
          holiday?.location_id?.includes(baselocationid)
      );
      return (
        <>
          <div>{arg.dayNumberText}</div>
          {matchedHoliday && (
            <div style={{ display: "flex", justifyContent: "center", fontSize: "14px", color: "#000", marginTop: "5px", fontWeight: "bold" }}>
              {matchedHoliday.holiday_name}
            </div>
          )}
        </>
      );
    } else {
      const holiday = holidayList?.find(
        (holiday) =>
          moment(holiday.start_date).format("YYYY-MM-DD") <= dateStr &&
          moment(holiday.end_date).format("YYYY-MM-DD") >= dateStr &&
          holiday?.location_id?.includes(baselocationid)
      );
      return (
        <>
          {holiday && (
            <Tooltip title={`${holiday.holiday_name}`}>
              <div style={{ position: "absolute", top: "22px", left: "-10px", zIndex: 8 }}>
                <StyledHolidayBadge>H</StyledHolidayBadge>
              </div>
            </Tooltip>
          )}
          <div>{arg.dayNumberText}</div>
        </>
      );
    }
  }, [holidayList, baselocationid]);

  const renderEventContent = useCallback((info) => {
    const { status_id, having_cancel_request: havingCancelRequest } = info.event.extendedProps;
    const backgroundColor = getEventColor(status_id, havingCancelRequest);
    const borderColor = getEventBorderColor(status_id, havingCancelRequest);
    return (
      <StaffLeaveIndicatorInCalendar
        icon="team"
        leaveDetails={{ info, ...info.event.extendedProps }}
        isStaff={true}
        openEditLeaveModal={cancelLeaveRequest}
        EditLeaveModal={cancelLeave}
      >
        <div
          style={{
            padding: "5px",
            background: backgroundColor,
            border: `1px solid ${borderColor}`,
            color: "#000",
            height: "110%",
            minWidth: "auto",
            width: "100%",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {info.event.title}
          </span>
          <p style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {moment(info.event.start).format("hh:mm A")} ΓÇô {moment(info.event.end).format("hh:mm A")}
          </p>
        </div>
      </StaffLeaveIndicatorInCalendar>
    );
  }, [cancelLeaveRequest, cancelLeave]);

  return (
    <>
    <Stylediv>
      <Spin spinning={displayLoader}>
        <FullCalendar
          ref={calendarRef}
          plugins={FC_PLUGINS}
          height="auto"
          dateClick={(info) => addLeave(info.event, info.date)}
          contentHeight="auto"
          initialView="timeGridWeek"
          events={events}
          headerToolbar={FC_HEADER_TOOLBAR}
          datesSet={handleDatesSet}
          editable={false}
          selectable={true}
          allDaySlot={false}
          eventOverlap={false}
          slotEventOverlap={true}
          slotMinTime="08:00:00"
          slotMaxTime="18:00:00"
          hiddenDays={FC_HIDDEN_DAYS}
          dayCellClassNames={renderDayCellClassNames}
          dayCellContent={renderDayCellContent}
          eventContent={renderEventContent}
        />
      </Spin>
      </Stylediv>

      <LeaveForm
        isModalVisible={displayLeaveModal}
        closeModal={() => toggleLeaveModal(false)}
        leaveDetails={leaveDetails}
        getLeaveList={getLeaveList}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  menuList: getMenuList(state),
  leaveCategoryList: getLeaveCategoryList(state),
  userList: getUserList(state),
  roleList: getRoleList(state),
  clientId: getClientid(state),
});

export default connect(mapStateToProps, null)(LeaveWeekCalendar);
